const Nav = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
    <path d="M20,18H2c-0.6,0-1-0.4-1-1s0.4-1,1-1h18c0.6,0,1,0.4,1,1S20.6,18,20,18z M20,12H2c-0.6,0-1-0.4-1-1s0.4-1,1-1h18 c0.6,0,1,0.4,1,1S20.6,12,20,12z M20,6H2C1.4,6,1,5.6,1,5s0.4-1,1-1h18c0.6,0,1,0.4,1,1S20.6,6,20,6z" />
  </svg>
);

export default Nav;
